function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "noora-logo"
}, React.createElement("polygon", {
  id: "Base",
  points: "0 0 114 0 114 26 0 26"
}), React.createElement("path", {
  d: "M0,0 L8.7898047,10.4640532 C10.2191017,12.1655973 11,14.2963906 11,16.4948893 L11,25 L0,25 L0,0 Z",
  id: "applogo",
  fill: "#E6653E"
}), React.createElement("path", {
  d: "M13,1 L24,1 L24,26 L15.2101953,15.5359468 C13.7808983,13.8344027 13,11.7036094 13,9.50511068 L13,1 Z",
  id: "applogo",
  fill: "#E6653E"
}), React.createElement("path", {
  d: "M109,19.8794838 C107.780042,21.0114547 106.211347,21.6923077 104.5,21.6923077 C100.612765,21.6923077 97.4615385,18.179465 97.4615385,13.8461538 C97.4615385,9.51284273 100.612765,6 104.5,6 C106.211347,6 107.780042,6.68085301 109,7.81282389 L109,6.46153846 L113.615385,6.46153846 L113.615385,21.2307692 L109,21.2307692 L109,19.8794838 Z M102.076923,13.8892547 C102.076923,16.073032 103.525266,17.5384615 105.495011,17.5384615 C107.493724,17.5384615 109,15.9868303 109,13.8317869 C109,11.6192757 107.464757,10.1538462 105.495011,10.1538462 C103.496299,10.1538462 102.076923,11.6767435 102.076923,13.8892547 Z",
  id: "applogo",
  fill: "#E6653E"
}), React.createElement("path", {
  d: "M97.2307692,10.2692308 C96.938288,10.1821841 96.6284489,10.1538462 96.3076923,10.1538462 C94.5233877,10.1538462 93.0769231,11.6003108 93.0769231,13.3846154 L93.0769231,21.2307692 L88.4615385,21.2307692 L88.4615385,6.46153846 L93.0769231,6.46153846 L93.0769231,7.78041632 C93.9870559,6.69218666 95.3550012,6 96.8846154,6 C97.0009791,6 97.1164072,6.00400585 97.2307692,6.01188716 L97.2307692,10.2692308 Z",
  id: "applogo",
  fill: "#E6653E"
}), React.createElement("path", {
  d: "M62.3846154,21.6923077 C57.9238539,21.6923077 54.3076923,18.179465 54.3076923,13.8461538 C54.3076923,9.51284273 57.9238539,6 62.3846154,6 C66.8453768,6 70.4615385,9.51284273 70.4615385,13.8461538 C70.4615385,18.179465 66.8453768,21.6923077 62.3846154,21.6923077 Z M58.9230769,13.8892547 C58.9230769,16.073032 60.3714194,17.5384615 62.3411651,17.5384615 C64.3398777,17.5384615 65.8461538,15.9868303 65.8461538,13.8317869 C65.8461538,11.6192757 64.3109108,10.1538462 62.3411651,10.1538462 C60.3424525,10.1538462 58.9230769,11.6767435 58.9230769,13.8892547 Z",
  id: "applogo",
  fill: "#E6653E"
}), React.createElement("path", {
  d: "M79.4615385,21.6923077 C75.000777,21.6923077 71.3846154,18.179465 71.3846154,13.8461538 C71.3846154,9.51284273 75.000777,6 79.4615385,6 C83.9222999,6 87.5384615,9.51284273 87.5384615,13.8461538 C87.5384615,18.179465 83.9222999,21.6923077 79.4615385,21.6923077 Z M76,13.8892547 C76,16.073032 77.4483425,17.5384615 79.4180882,17.5384615 C81.4168008,17.5384615 82.9230769,15.9868303 82.9230769,13.8317869 C82.9230769,11.6192757 81.3878339,10.1538462 79.4180882,10.1538462 C77.4193756,10.1538462 76,11.6767435 76,13.8892547 Z",
  id: "applogo",
  fill: "#E6653E"
}), React.createElement("path", {
  d: "M48.7692308,21.2307692 L48.7692308,12.2307692 C48.7692308,11.0837163 47.8393606,10.1538462 46.6923077,10.1538462 C45.5452548,10.1538462 44.6153846,11.0837163 44.6153846,12.2307692 L44.6153846,21.2307692 L40,21.2307692 L40,6.46153846 L44.6153846,6.46153846 L44.6153846,7.78041632 C45.5255174,6.69218666 46.8934627,6 48.4230769,6 C51.163259,6 53.3846154,8.22135643 53.3846154,10.9615385 L53.3846154,21.2307692 L48.7692308,21.2307692 Z",
  id: "applogo",
  fill: "#E6653E"
})));

var SvgNoora = function SvgNoora(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    className: "noora-logo",
    width: "114px",
    height: "26px",
    viewBox: "0 0 114 26",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoora, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noora.5838ccb0.svg";
export { ForwardRef as ReactComponent };